import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { routes } from '../../../constants/routes';
import { RouterLink } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { ApiService } from '../../../services/api.service';
import { finalize, Subscription } from 'rxjs';
import { StatsResponse } from '../../../models/home-stats.model';
import { StatsThreshhold } from '../../../constants/stats-threshhold';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { ApiErrorHandler } from '../../../models/api-error-handler.model';
import { ToasterService } from '../../../services/toaster.service';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.scss',
})
export class statsComponent implements OnInit, OnDestroy, ApiErrorHandler {
  readonly routes = routes;
  readonly statThreshold = StatsThreshhold;
  fetchStatsSub!: Subscription;
  stats: StatsResponse;

  constructor(
    private renderer: Renderer2,
    public toaster: ToasterService,
    private apiService: ApiService,
    public utilityService: UtilityService,
  ) {}

  ngOnInit(): void {
    this.getStats();
  }

  scrollToExploreBySector() {
    const escapedId = `#explore_by_sector`;

    const element = this.renderer.selectRootElement(escapedId, true);
    if (element) {
      const elementHeight = element.getBoundingClientRect().top || 0;
      const top =
        elementHeight + window.scrollY - (window.innerWidth <= 768 ? 153 : 90);

      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  getStats() {
    // this.isResourcesLoading = true;
    this.fetchStatsSub = this.apiService
      .fetchArtefactStats()
      .pipe(
        finalize(() => {
          // this.isResourcesLoading = false;
        }),
      )
      .subscribe({
        next: (resp) => {
          if (!resp.header.success) {
            return;
          }
          this.stats = resp.data;
        },
        error: apiErrorHandler.bind(this),
      });
  }

  addPlusIfGreater(value: string, threshold: number) {
    // Check if the value is greater than the threshold

    if (parseInt(value) > threshold) {
      return value + '+';
    }
    // Return the original value if it's not greater
    return value;
  }

  ngOnDestroy(): void {
    this.fetchStatsSub.unsubscribe();
  }
}
